import { useState } from 'react'

const useReplyForms = (
  initialValues: {
    userId: string | null
    eventId: any
    comment: string
    parentId: null
  },
  commentIds: string[],
) => {
  const [formValues, setFormValues] = useState<{ [key: string]: any }>({})

  // Function to get form values for a specific comment ID
  const getFormValues = (id: string) => formValues[id] || initialValues

  // Function to set form value for a specific comment ID
  const setFormValue = (id: string, field: string, value: any) => {
    setFormValues(prevFormValues => ({
      ...prevFormValues,
      [id]: {
        ...prevFormValues[id],
        [field]: value,
      },
    }))
  }

  return {
    getFormValues,
    setFormValue,
  }
}

export default useReplyForms
